import React from "react";
import cx from "classnames";
import { Input } from "reactstrap";
import Button from "../../components/Button/Button";
import { addNew } from "../../services/textsForm";
import styles from "../SpotForm/SpotForm.module.scss";
import hotSpotStyles from "../HotSpotForm/HotSpotForm.module.scss";

const ThirdStep = ({ state }) => {
    const {
        photos, setPhotos,
        links, setLinks,
        videos, setVideos,
        relatedOrganizations, setRelatedOrganizations,
        titleSeo, setTitleSeo,
        descriptionSeo, setDescriptionSeo,
        validationError, setValidationError, changeMultipleFieldsObject, changeValidationError,
        addFieldObject,
    } = state
    const firstPhotos = [...photos];
    const lastPhoto = firstPhotos.pop();

    const firstVideos = [...videos];
    const lastVideo = firstVideos.pop();

    const firstRelatedOrganizations = [...relatedOrganizations];
    const lastRelatedOrganization = firstRelatedOrganizations.pop();

    const firstLinks = [...links];
    const lastLink = firstLinks.pop();
    return (
        <div>
            {/* Photos */}
            <div className={hotSpotStyles.linkContainer}>
                <p className={hotSpotStyles.title}>Photos</p>
                {firstPhotos?.map((photo, index) => (
                    <div className={cx(hotSpotStyles.linkForms, hotSpotStyles.photosContainer)} key={index}>
                        <div className={hotSpotStyles.linkFormsChild}>
                            <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.photoTitleUrl}</p>
                                <p className={hotSpotStyles.inspirationText}>{addNew.photoTitleUrlText}</p>
                            </div>
                            <Input
                                placeholder={addNew.photoUrl}
                                className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                    [styles.inputError]: validationError.indexOf("photos") !== -1,
                                })}
                                onChange={(e) => {
                                    changeMultipleFieldsObject(
                                        'photoUrl',
                                        e.target.value,
                                        index,
                                        setPhotos,
                                        photos
                                    );
                                    setValidationError(
                                        validationError.filter((errorItem) => errorItem !== "photos")
                                    );
                                }}
                                value={photo.url}
                            />
                            <p
                                className={cx(styles.errorLabel, {
                                    "d-block": validationError.indexOf("photos") !== -1,
                                })}
                            >
                                {addNew.error}
                            </p>
                        </div>
                        <div className={hotSpotStyles.linkFormsChild}>
                            <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.photoTitleUrlAlt}</p>
                                <p className={hotSpotStyles.inspirationText}>{addNew.photoTitleUrlAltText}</p>
                            </div>
                            <div className={hotSpotStyles.nameButtonContainer}>
                                <Input
                                    placeholder={addNew.photoAlt}
                                    className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                        [styles.inputError]: validationError.indexOf("photos") !== -1,
                                    })}
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            'photoAlt',
                                            e.target.value,
                                            index,
                                            setPhotos,
                                            photos
                                        );
                                        setValidationError(
                                            validationError.filter((errorItem) => errorItem !== "photos")
                                        );
                                    }}
                                    value={photo.alt}
                                />
                                <p
                                    className={cx(styles.errorLabel, {
                                        "d-block": validationError.indexOf("photos") !== -1,
                                    })}
                                >
                                    {addNew.error}
                                </p>
                            </div>
                        </div>
                        <div className={hotSpotStyles.linkFormsChild}>
                            <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                <p className={hotSpotStyles.fieldLabelUrlTitle}>PHOTO SOURCE</p>
                                <p className={hotSpotStyles.inspirationText}>Photo original source URL</p>
                            </div>
                            <div className={hotSpotStyles.nameButtonContainer}>
                                <Input
                                    placeholder={"Photo source"}
                                    className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                        [styles.inputError]: validationError.indexOf("photos") !== -1,
                                    })}
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            'photoSource',
                                            e.target.value,
                                            index,
                                            setPhotos,
                                            photos
                                        );
                                        setValidationError(
                                            validationError.filter((errorItem) => errorItem !== "photos")
                                        );
                                    }}
                                    value={photo?.photoSource}
                                />
                                <p
                                    className={cx(styles.errorLabel, {
                                        "d-block": validationError.indexOf("photos") !== -1,
                                    })}
                                >
                                    {addNew.error}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
                <div className={cx(hotSpotStyles.linkForms, hotSpotStyles.photosContainer)}>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.photoTitleUrl}</p>
                            <p className={hotSpotStyles.inspirationText}>{addNew.photoTitleUrlText}</p>
                        </div>
                        <Input
                            placeholder={addNew.photoUrl}
                            className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                [styles.inputError]: validationError.indexOf("photos") !== -1,
                            })}
                            onChange={(e) => {
                                changeMultipleFieldsObject(
                                    'photoUrl',
                                    e.target.value,
                                    photos.length - 1,
                                    setPhotos,
                                    photos
                                );
                                setValidationError(
                                    validationError.filter((errorItem) => errorItem !== "photos")
                                );
                            }}
                            value={lastPhoto?.url ?? ""}
                        />
                        <p
                            className={cx(styles.errorLabel, {
                                "d-block": validationError.indexOf("photos") !== -1,
                            })}
                        >
                            {addNew.error}
                        </p>
                    </div>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.photoTitleUrlAlt}</p>
                            <p className={hotSpotStyles.inspirationText}>{addNew.photoTitleUrlAltText}</p>
                        </div>
                        <div className={hotSpotStyles.nameButtonContainer}>
                            <Input
                                placeholder={addNew.photoAlt}
                                className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                    [styles.inputError]: validationError.indexOf("photos") !== -1,
                                })}
                                onChange={(e) => {
                                    changeMultipleFieldsObject(
                                        'photoAlt',
                                        e.target.value,
                                        photos.length - 1,
                                        setPhotos,
                                        photos
                                    );
                                    setValidationError(
                                        validationError.filter((errorItem) => errorItem !== "photos")
                                    );
                                }}
                                value={lastPhoto?.alt ?? ""}
                            />
                            <p
                                className={cx(styles.errorLabel, {
                                    "d-block": validationError.indexOf("photos") !== -1,
                                })}
                            >
                                {addNew.error}
                            </p>


                        </div>
                    </div>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>PHOTO SOURCE</p>
                            <p className={hotSpotStyles.inspirationText}>Photo original source URL</p>
                        </div>
                        <div className={hotSpotStyles.nameButtonContainer}>
                            <Input
                                placeholder={"Photo source"}
                                className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                    [styles.inputError]: validationError.indexOf("photos") !== -1,
                                })}
                                onChange={(e) => {
                                    changeMultipleFieldsObject(
                                        'photoSource',
                                        e.target.value,
                                        photos.length - 1,
                                        setPhotos,
                                        photos
                                    );
                                    setValidationError(
                                        validationError.filter((errorItem) => errorItem !== "photos")
                                    );
                                }}
                                value={lastPhoto?.photoSource}
                            />
                            <p
                                className={cx(styles.errorLabel, {
                                    "d-block": validationError.indexOf("photos") !== -1,
                                })}
                            >
                                {addNew.error}
                            </p>
                        </div>
                    </div>
                    <Button className={hotSpotStyles.plusButtonLink} onClick={() => addFieldObject(setPhotos, photos)} disabled={!!lastPhoto && !Object.keys(lastPhoto).length} >+</Button>
                </div>

            </div>
            {/* Links */}
            <div className={hotSpotStyles.linkContainer}>
                <p className={hotSpotStyles.title}>Links</p>
                {
                    firstLinks?.map((link, index) => (
                        <div className={hotSpotStyles.linkForms} key={index}>
                            <div className={hotSpotStyles.linkFormsChild}>
                                <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                    <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.linkTitleUrl}</p>
                                    <p className={hotSpotStyles.inspirationText}>{addNew.linkTitleUrlText}</p>
                                </div>
                                <Input
                                    placeholder={addNew.linkUrl}
                                    className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                        [styles.inputError]: validationError.indexOf("links") !== -1,
                                    })}
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            'linkUrl',
                                            e.target.value,
                                            index,
                                            setLinks,
                                            links
                                        );
                                        setValidationError(
                                            validationError.filter((errorItem) => errorItem !== "links")
                                        );
                                    }}
                                    value={link.url}
                                />
                                <p
                                    className={cx(styles.errorLabel, {
                                        "d-block": validationError.indexOf("links") !== -1,
                                    })}
                                >
                                    {addNew.error}
                                </p>
                            </div>
                            <div className={hotSpotStyles.linkFormsChild}>
                                <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                    <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.linkTitleUrlAlt}</p>
                                    <p className={hotSpotStyles.inspirationText}>{addNew.linkTitleUrlAltText}</p>
                                </div>
                                <div className={hotSpotStyles.nameButtonContainer}>
                                    <Input
                                        placeholder={addNew.linkName}
                                        className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                            [styles.inputError]: validationError.indexOf("links") !== -1,
                                        })}
                                        onChange={(e) => {
                                            changeMultipleFieldsObject(
                                                'linkName',
                                                e.target.value,
                                                index,
                                                setLinks,
                                                links
                                            );
                                            setValidationError(
                                                validationError.filter((errorItem) => errorItem !== "links")
                                            );
                                        }}
                                        value={link.name}
                                    />
                                    <p
                                        className={cx(styles.errorLabel, {
                                            "d-block": validationError.indexOf("links") !== -1,
                                        })}
                                    >
                                        {addNew.error}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                }

                <div className={hotSpotStyles.linkForms}>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.linkTitleUrl}</p>
                            <p className={hotSpotStyles.inspirationText}>{addNew.linkTitleUrlText}</p>
                        </div>
                        <Input
                            placeholder={addNew.linkUrl}
                            className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                [styles.inputError]: validationError.indexOf("links") !== -1,
                            })}
                            onChange={(e) => {
                                changeMultipleFieldsObject(
                                    'linkUrl',
                                    e.target.value,
                                    links.length - 1,
                                    setLinks,
                                    links
                                );
                                setValidationError(
                                    validationError.filter((errorItem) => errorItem !== "links")
                                );
                            }}
                            value={lastLink.url ?? ""}
                        />
                        <p
                            className={cx(styles.errorLabel, {
                                "d-block": validationError.indexOf("links") !== -1,
                            })}
                        >
                            {addNew.error}
                        </p>
                    </div>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.linkTitleUrlAlt}</p>
                            <p className={hotSpotStyles.inspirationText}>{addNew.linkTitleUrlAltText}</p>
                        </div>
                        <div className={hotSpotStyles.nameButtonContainer}>
                            <Input
                                placeholder={addNew.linkName}
                                className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                    [styles.inputError]: validationError.indexOf("links") !== -1,
                                })}
                                onChange={(e) => {
                                    changeMultipleFieldsObject(
                                        'linkName',
                                        e.target.value,
                                        links.length - 1,
                                        setLinks,
                                        links
                                    );
                                    setValidationError(
                                        validationError.filter((errorItem) => errorItem !== "links")
                                    );
                                }}
                                value={lastLink?.name ?? ""}
                            />
                            <p
                                className={cx(styles.errorLabel, {
                                    "d-block": validationError.indexOf("links") !== -1,
                                })}
                            >
                                {addNew.error}
                            </p>

                            <Button className={hotSpotStyles.plusButtonLink} onClick={() => addFieldObject(setLinks, links)} disabled={!!lastLink && !Object.keys(lastLink).length} >+</Button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Videos */}
            <div className={hotSpotStyles.linkContainer}>
                <p className={hotSpotStyles.title}>Videos</p>
                {
                    firstVideos.map((video, index) => (
                        <div className={hotSpotStyles.linkForms} key={index}>
                            <div className={hotSpotStyles.linkFormsChild}>
                                <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                    <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.videoTitleUrl}</p>
                                    <p className={hotSpotStyles.inspirationText}>{addNew.videoTitleUrlText}</p>
                                </div>
                                <Input
                                    placeholder={addNew.videoUrl}
                                    className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                        [styles.inputError]: validationError.indexOf("videos") !== -1,
                                    })}
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            'videoUrl',
                                            e.target.value,
                                            index,
                                            setVideos,
                                            videos
                                        );
                                        setValidationError(
                                            validationError.filter((errorItem) => errorItem !== "videos")
                                        );
                                    }}
                                    value={video.url}
                                />
                                <p
                                    className={cx(styles.errorLabel, {
                                        "d-block": validationError.indexOf("videos") !== -1,
                                    })}
                                >
                                    {addNew.error}
                                </p>
                            </div>
                            <div className={hotSpotStyles.linkFormsChild}>
                                <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                    <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.videoTitleUrlAlt}</p>
                                    <p className={hotSpotStyles.inspirationText}>{addNew.videoTitleUrlAltText}</p>
                                </div>
                                <div className={hotSpotStyles.nameButtonContainer}>
                                    <Input
                                        placeholder={addNew.videoTitle}
                                        className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                            [styles.inputError]: validationError.indexOf("videos") !== -1,
                                        })}
                                        onChange={(e) => {
                                            changeMultipleFieldsObject(
                                                'videoTitle',
                                                e.target.value,
                                                index,
                                                setVideos,
                                                videos
                                            );
                                            setValidationError(
                                                validationError.filter((errorItem) => errorItem !== "videos")
                                            );
                                        }}
                                        value={video.title}
                                    />
                                    <p
                                        className={cx(styles.errorLabel, {
                                            "d-block": validationError.indexOf("videos") !== -1,
                                        })}
                                    >
                                        {addNew.error}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                }
                <div className={hotSpotStyles.linkForms}>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.videoTitleUrl}</p>
                            <p className={hotSpotStyles.inspirationText}>{addNew.videoTitleUrlText}</p>
                        </div>
                        <Input
                            placeholder={addNew.videoUrl}
                            className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                [styles.inputError]: validationError.indexOf("videos") !== -1,
                            })}
                            onChange={(e) => {
                                changeMultipleFieldsObject(
                                    'videoUrl',
                                    e.target.value,
                                    videos.length - 1,
                                    setVideos,
                                    videos
                                );
                                setValidationError(
                                    validationError.filter((errorItem) => errorItem !== "videos")
                                );
                            }}
                            value={lastVideo.url ?? ""}
                        />
                        <p
                            className={cx(styles.errorLabel, {
                                "d-block": validationError.indexOf("videos") !== -1,
                            })}
                        >
                            {addNew.error}
                        </p>
                    </div>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.videoTitleUrlAlt}</p>
                            <p className={hotSpotStyles.inspirationText}>{addNew.videoTitleUrlAltText}</p>
                        </div>
                        <div className={hotSpotStyles.nameButtonContainer}>
                            <Input
                                placeholder={addNew.videoTitle}
                                className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                    [styles.inputError]: validationError.indexOf("videos") !== -1,
                                })}
                                onChange={(e) => {
                                    changeMultipleFieldsObject(
                                        'videoTitle',
                                        e.target.value,
                                        videos.length - 1,
                                        setVideos,
                                        videos
                                    );
                                    setValidationError(
                                        validationError.filter((errorItem) => errorItem !== "videos")
                                    );
                                }}
                                value={lastVideo?.title ?? ""}
                            />
                            <p
                                className={cx(styles.errorLabel, {
                                    "d-block": validationError.indexOf("videos") !== -1,
                                })}
                            >
                                {addNew.error}
                            </p>

                            <Button className={hotSpotStyles.plusButtonLink} onClick={() => addFieldObject(setVideos, videos)} disabled={!!lastVideo && !Object.keys(lastVideo).length} >+</Button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Related Org */}
            <div className={hotSpotStyles.linkContainer}>
                <p className={hotSpotStyles.title}>Related Organizations</p>
                {
                    firstRelatedOrganizations.map((org, index) => (
                        <div className={hotSpotStyles.linkForms} key={index}>
                            <div className={hotSpotStyles.linkFormsChild}>
                                <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                    <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.orgTitleUrl}</p>
                                    <p className={hotSpotStyles.inspirationText}>{addNew.orgTitleUrlText}</p>
                                </div>
                                <Input
                                    placeholder={addNew.orgUrl}
                                    className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                        [styles.inputError]: validationError.indexOf("relatedOrganizations") !== -1,
                                    })}
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            'orgUrl',
                                            e.target.value,
                                            index,
                                            setRelatedOrganizations,
                                            relatedOrganizations
                                        );
                                        setValidationError(
                                            validationError.filter((errorItem) => errorItem !== "relatedOrganizations")
                                        );
                                    }}
                                    value={org.url}
                                />
                                <p
                                    className={cx(styles.errorLabel, {
                                        "d-block": validationError.indexOf("relatedOrganizations") !== -1,
                                    })}
                                >
                                    {addNew.error}
                                </p>
                            </div>
                            <div className={hotSpotStyles.linkFormsChild}>
                                <div className={hotSpotStyles.fieldLabelUrlContainer}>
                                    <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.orgTitleUrlAlt}</p>
                                    <p className={hotSpotStyles.inspirationText}>{addNew.orgTitleUrlAltText}</p>
                                </div>
                                <div className={hotSpotStyles.nameButtonContainer}>
                                    <Input
                                        placeholder={addNew.orgName}
                                        className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                            [styles.inputError]: validationError.indexOf("relatedOrganizations") !== -1,
                                        })}
                                        onChange={(e) => {
                                            changeMultipleFieldsObject(
                                                'orgName',
                                                e.target.value,
                                                index,
                                                setRelatedOrganizations,
                                                relatedOrganizations
                                            );
                                            setValidationError(
                                                validationError.filter((errorItem) => errorItem !== "relatedOrganizations")
                                            );
                                        }}
                                        value={org.name}
                                    />
                                    <p
                                        className={cx(styles.errorLabel, {
                                            "d-block": validationError.indexOf("relatedOrganizations") !== -1,
                                        })}
                                    >
                                        {addNew.error}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                }
                <div className={hotSpotStyles.linkForms}>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.orgTitleUrl}</p>
                            <p className={hotSpotStyles.inspirationText}>{addNew.orgTitleUrlText}</p>
                        </div>
                        <Input
                            placeholder={addNew.orgUrl}
                            className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                [styles.inputError]: validationError.indexOf("relatedOrganizations") !== -1,
                            })}
                            onChange={(e) => {
                                changeMultipleFieldsObject(
                                    'orgUrl',
                                    e.target.value,
                                    relatedOrganizations.length - 1,
                                    setRelatedOrganizations,
                                    relatedOrganizations
                                );
                                setValidationError(
                                    validationError.filter((errorItem) => errorItem !== "relatedOrganizations")
                                );
                            }}
                            value={lastRelatedOrganization.url ?? ""}
                        />
                        <p
                            className={cx(styles.errorLabel, {
                                "d-block": validationError.indexOf("relatedOrganizations") !== -1,
                            })}
                        >
                            {addNew.error}
                        </p>
                    </div>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.orgTitleUrlAlt}</p>
                            <p className={hotSpotStyles.inspirationText}>{addNew.orgTitleUrlAltText}</p>
                        </div>
                        <div className={hotSpotStyles.nameButtonContainer}>
                            <Input
                                placeholder={addNew.orgName}
                                className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                    [styles.inputError]: validationError.indexOf("relatedOrganizations") !== -1,
                                })}
                                onChange={(e) => {
                                    changeMultipleFieldsObject(
                                        'orgName',
                                        e.target.value,
                                        relatedOrganizations.length - 1,
                                        setRelatedOrganizations,
                                        relatedOrganizations
                                    );
                                    setValidationError(
                                        validationError.filter((errorItem) => errorItem !== "relatedOrganizations")
                                    );
                                }}
                                value={lastRelatedOrganization?.name ?? ""}
                            />
                            <p
                                className={cx(styles.errorLabel, {
                                    "d-block": validationError.indexOf("relatedOrganizations") !== -1,
                                })}
                            >
                                {addNew.error}
                            </p>

                            <Button className={hotSpotStyles.plusButtonLink} onClick={() => addFieldObject(setRelatedOrganizations, relatedOrganizations)} disabled={!!lastRelatedOrganization && !Object.keys(lastRelatedOrganization).length} >+</Button>
                        </div>
                    </div>
                </div>
            </div>
            {/* SEO */}
            <div className={hotSpotStyles.linkContainer}>
                <p className={hotSpotStyles.title}>SEO</p>
                <div className={hotSpotStyles.linkForms}>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.titleSeo}</p>
                        </div>
                        <Input
                            placeholder={addNew.titleSeo}
                            className={cx(hotSpotStyles.input, hotSpotStyles.linkUrl, {
                                [styles.inputError]: validationError.indexOf("titleSeo") !== -1,
                            })}
                            onChange={(e) => {
                                setTitleSeo(e.target.value)
                                setValidationError(
                                    validationError.filter((errorItem) => errorItem !== "titleSeo")
                                );
                            }}
                            value={titleSeo}
                        />
                        <p
                            className={cx(styles.errorLabel, {
                                "d-block": validationError.indexOf("titleSeo") !== -1,
                            })}
                        >
                            {addNew.error}
                        </p>
                    </div>
                    <div className={hotSpotStyles.linkFormsChild}>
                        <div className={hotSpotStyles.fieldLabelUrlContainer}>
                            <p className={hotSpotStyles.fieldLabelUrlTitle}>{addNew.descSeo}</p>
                        </div>
                        <div className={hotSpotStyles.nameButtonContainer}>
                            <Input
                                placeholder={addNew.descSeo}
                                className={cx(hotSpotStyles.input, hotSpotStyles.linkAlt, {
                                    [styles.inputError]: validationError.indexOf("descriptionSeo") !== -1,
                                })}
                                onChange={(e) => {
                                    setDescriptionSeo(e.target.value)
                                    setValidationError(
                                        validationError.filter((errorItem) => errorItem !== "descriptionSeo")
                                    );
                                }}
                                value={descriptionSeo}
                            />
                            <p
                                className={cx(styles.errorLabel, {
                                    "d-block": validationError.indexOf("descriptionSeo") !== -1,
                                })}
                            >
                                {addNew.error}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ThirdStep